<template>
<div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
            <v-layout row wrap>
                <v-toolbar size="120px"  dark color="info">
                    <v-toolbar-title class="baslikfont">{{ $t('List-of-Invoices-Received') }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-menu >
                        <v-btn :disabled="!sayfayetki.Save" slot="activator" flat>
                            <v-icon>add_box</v-icon> &nbsp; {{ $t('Add-v2', { value: $t('Invoice-Received')}) }}  
                        </v-btn>
                        <v-list>

                            <v-list-tile @click="gelentfaturaEkle(1)">
                                <v-list-tile-title>{{$t('Add-Current-Incoming-Invoice')}}  </v-list-tile-title>
                            </v-list-tile>

                            <v-list-tile @click="gelentfaturaEkle(2)">
                                <v-list-tile-title>{{$t('Add-Coper-Incoming-Invoice')}} </v-list-tile-title>
                            </v-list-tile>

                        </v-list>

                    </v-menu>

                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <v-menu offset-y>
                        <v-btn slot="activator" dark icon>
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                        <v-list>

                            <v-list-tile @click="getListHtml()">
                                <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                            </v-list-tile>

                            <v-list-tile @click="getListExcel()">
                                <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                            </v-list-tile>

                        </v-list>
                    </v-menu>
                </v-toolbar>

                <v-container fluid="">
                    <v-layout row wrap="">
                        <v-flex xs12 sm4 md2>
                            <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>

                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>

                        </v-flex>
                        <v-flex>
                            <v-layout>
                                <div v-if="load1">
                                    <v-btn color="info" @click="getList(1,kayitadet,siralamatipi,true)" fab small="" dark>
                                        <v-icon>search</v-icon>
                                    </v-btn>
                                </div>
                                <div v-if="!load1">
                                    <v-layout align-center="" fill-height>
                                        <v-progress-circular indeterminate color="info"></v-progress-circular>
                                    </v-layout>
                                </div>
                                <v-badge color="white" :overlap="true">
                                    <template v-slot:badge>
                                        <v-icon v-if="filtrevarmi" large color="green">
                                            check_circle_outline </v-icon>
                                    </template>

                                    <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>
                                        <v-icon>filter_list</v-icon>
                                    </v-btn>
                                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                        <span>{{$t('Add-Search-Filter')}}</span>
                                    </v-tooltip>

                                </v-badge>
                            </v-layout>
                        </v-flex>

                    </v-layout>
                </v-container>

                <v-layout row="" wrap>
                    <v-flex xs12 sm12 md12>
                        <v-card>

                        </v-card>
                    </v-flex>
                </v-layout>

                <!--
          <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items="items" :search="search3">
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.FaturaTarih | dateformat  }}</td>
                      <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                      <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                      <td class="text-xs-left">{{ props.item.CariKodu}}</td>
                      <td class="text-xs-left">{{ props.item.Tutar | moneyformat}}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search3 }}" found no results.
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout> -->

                <v-layout row="" wrap>
                    <v-flex xs12 sm12 md12>
                        <v-card color="grey lighten-5" flat>
                            <v-flex v-show="kayitvarmi" xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md9>
                                        <v-layout align-center="" fill-height="">
                                            <div class=" font-weight-large grey--text title ">
                                                &nbsp; {{recordcount}} <span v-if="secilenkayitlar.length>0" class=" font-weight-large red--text title ">
                                                    / {{secilenkayitlar.length}} {{ $t('Records-are-selected') }} </span>
                                            </div>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex v-show="kayitvarmi" xs12 sm12 md2>
                                        <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1" v-model="siralamatipi" item-text="text" item-value="value" :label="$t('Sort-By')"></v-select>
                                    </v-flex>
                                    <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                                        <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet" item-text="text" item-value="value" :label="$t('Show')"></v-select>
                                    </v-flex>
                                </v-layout>

                                <!-- <v-layout>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-layout v-if="kayitvarmi" justify-center="" align-center>
                              <v-checkbox v-model="tumunuseckaldir" :label="$t('Choose-All')"></v-checkbox>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-layout> -->

                            </v-flex>

                            <v-flex pa-2 v-for="item in items" v-bind:key="item.id" xs12 sm12 md12>
                                <v-hover>
                                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                                        <v-list two-line="">
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-card flat class="black--text">
                                                        <v-card flat="">
                                                            <v-card-actions>
                                                                <v-layout row wrap>
                                                                    <!--  <v-list-tile>
                                      <v-list-tile-content>
                                        <v-layout justify-center="" align-center>
                                          <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item">
                                          </v-checkbox>
                                        </v-layout>
                                      </v-list-tile-content>
                                    </v-list-tile> -->

                                                                    <v-flex xs12 sm4 md2>
                                                                        <v-layout v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" align-center justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content>
                                                                                        <v-layout row align-center justify-start>

                                                                                            <v-chip v-if="item.Program==3" color="info" text-color="white">
                                                                                                &nbsp;
                                                                                                <v-avatar>
                                                                                                    <v-icon color="white">receipt</v-icon>
                                                                                                </v-avatar>
                                                                                                Coper {{ $t('Invoice-Received') }}
                                                                                            </v-chip>

                                                                                            <v-chip v-if="item.Program!=3" color="red" text-color="white">
                                                                                                &nbsp;
                                                                                                <v-avatar>
                                                                                                    <v-icon color="white">receipt</v-icon>
                                                                                                </v-avatar>
                                                                                                 {{ $t('Invoice-Received') }}
                                                                                            </v-chip>

                                                                                        </v-layout>

                                                                                        

                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>

                                                                        <v-layout v-show="$vuetify.breakpoint.xs" align-center justify-center row fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content>
                                                                                        <v-layout row align-center justify-center>

                                                                                            <v-chip small="" v-if="item.Program==3" color="info" text-color="white">
                                                                                                <v-avatar>
                                                                                                    <v-icon color="white">receipt</v-icon>
                                                                                                </v-avatar>
                                                                                                &nbsp;
                                                                                                Coper {{$t('Invoice-Received')}}
                                                                                            </v-chip>

                                                                                            <v-chip small="" v-if="item.Program!=3" color="red" text-color="white">
                                                                                                <v-avatar>
                                                                                                    <v-icon color="white">receipt</v-icon>
                                                                                                </v-avatar>
                                                                                                &nbsp;
                                                                                                Cari Gelen Fatura
                                                                                            </v-chip>

                                                                                        </v-layout>

                                                                                   

                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>

                                                                    </v-flex>

                                                                    <v-flex xs12 sm4 md2>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                                        <v-layout align-start="" row wrap justify-start fill-height>
                                                                                            <v-list-tile-sub-title>
                                                                                                <div class="font-weight- subheading ">
                                                                                                    <span class="red--text"> {{$t('Invoice-Date')}}</span>
                                                                                                    <v-divider></v-divider>
                                                                                                </div>
                                                                                            </v-list-tile-sub-title>

                                                                                            <v-list-tile-sub-title>
                                                                                                <v-layout>
                                                                                                    <div class="font-weight-bold caption">
                                                                                                        {{item.FaturaTarih | dateformat}}
                                                                                                    </div>
                                                                                                </v-layout>
                                                                                            </v-list-tile-sub-title>
                                                                                            <v-list-tile-sub-title>
                                                                                                <div class="font-weight caption ">
                                                                                                </div>
                                                                                            </v-list-tile-sub-title>
                                                                                        </v-layout>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>

                                                                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs2 sm2 md1>
                                                                        &nbsp;
                                                                    </v-flex>

                                                                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs1 sm1 md1>
                                                                        &nbsp;
                                                                    </v-flex>

                                                                    <v-flex xs12 sm4 md3>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-flex xs12 sm12 md12>
                                                                                <v-layout align-start="" justify-start fill-height>
                                                                                    <v-card flat="">
                                                                                        <v-list-tile>
                                                                                            <v-list-tile-content style="'overflow=inherit';">
                                                                                                <v-layout row wrap align-start="" justify-start fill-height>
                                                                                                    <v-list-tile-sub-title>
                                                                                                        <div class="font-weight- subheading ">
                                                                                                            <span class="red--text"> {{$t('Customer-Code')}}-Ünvanı</span></br>
                                                                                                            <v-divider></v-divider>
                                                                                                        </div>
                                                                                                    </v-list-tile-sub-title>

                                                                                                    <v-list-tile-sub-title>
                                                                                                        <v-layout>
                                                                                                            <div class="font-weight-bold caption">
                                                                                                                {{item.CariKodu}}
                                                                                                            </div>
                                                                                                        </v-layout>
                                                                                                    </v-list-tile-sub-title>
                                                                                                    <v-list-tile-sub-title>
                                                                                                        <div class="font-weight caption ">
                                                                                                            {{item.CariUnvani}}
                                                                                                        </div>
                                                                                                    </v-list-tile-sub-title>

                                                                                                </v-layout>
                                                                                            </v-list-tile-content>
                                                                                        </v-list-tile>
                                                                                    </v-card>
                                                                                </v-layout>
                                                                            </v-flex>

                                                                        </v-layout>
                                                                    </v-flex>

                                                                    <v-flex xs12 sm4 md2>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-flex xs12 sm12 md12>
                                                                                <v-layout align-start="" justify-start fill-height>
                                                                                    <v-card flat="">
                                                                                        <v-list-tile>
                                                                                            <v-list-tile-content style="'overflow=inherit';">
                                                                                                <v-layout row wrap align-start="" justify-start fill-height>
                                                                                                    <v-list-tile-sub-title>
                                                                                                        <div class="font-weight- subheading ">
                                                                                                            <span class="red--text">  {{ $t('Invoice-Serial-No') }} </span></br>
                                                                                                            <v-divider></v-divider>

                                                                                                        </div>
                                                                                                    </v-list-tile-sub-title>

                                                                                                    <v-list-tile-sub-title>
                                                                                                        <v-layout>
                                                                                                            <div class="font-weight-bold caption">
                                                                                                                {{item.FaturaSeri}} / {{item.FaturaNo}}
                                                                                                            </div>
                                                                                                        </v-layout>
                                                                                                    </v-list-tile-sub-title>
                                                                                                    <v-list-tile-sub-title>
                                                                                                        <div class="font-weight caption ">
                                                                                                        </div>
                                                                                                    </v-list-tile-sub-title>
                                                                                                </v-layout>
                                                                                            </v-list-tile-content>
                                                                                        </v-list-tile>
                                                                                    </v-card>
                                                                                </v-layout>
                                                                            </v-flex>

                                                                        </v-layout>
                                                                    </v-flex>

                                                                    <v-flex xs12 sm2 md2>
                                                                        <v-layout justify-center="" align-center="" fill-height="">
                                                                            <v-layout justify-center="" column="" fill-height="">
                                                                                <v-flex xs12 sm12 md12>
                                                                                    <v-layout justify-center="">
                                                                                        <v-card flat="" class="white--text">
                                                                                            <v-card-actions class="pa-3">
                                                                                                <v-layout row wrap justify-center="">
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-layout justify-center="">
                                                                                                            <span class="headline red--text font-weight-">
                                                                                                                {{item.Tutar | moneyformat}}{{getparabirimi()}}
                                                                                                            </span>
                                                                                                        </v-layout>
                                                                                                    </v-flex>

                                                                                                </v-layout>
                                                                                                <v-spacer></v-spacer>
                                                                                            </v-card-actions>
                                                                                        </v-card>
                                                                                    </v-layout>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-layout>
                                                                    </v-flex>

                                                                    <v-flex xs6 sm4 md1>
                                                                        <v-layout align-end="" justify-start="" fill-height="">
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content>

                                                     

                                                                                        <v-list-tile-sub-title>
                                                                                            <v-layout row wrap>

                                                                                                <v-flex xs12 sm12 md12>

                                                                                                    <v-btn @click="git(item)" icon>
                                                                                                        <v-icon large color="info">search</v-icon>
                                                                                                    </v-btn>

                                                                                                </v-flex>

                                                                                            </v-layout>
                                                                                        </v-list-tile-sub-title>

                                                                             
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>

                                                                </v-layout>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-list>
                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-container>
                    <v-layout justify-center="">
                        <template v-if="vmodelpagination">
                            <div class="text-xs-center">
                                <v-container>
                                    <v-layout justify-center>
                                        <v-flex>
                                            <v-pagination v-model="sayfalama" :length="pagenumber" :total-visible="7"></v-pagination>

                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </div>
                        </template>
                    </v-layout>
                </v-container>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                </v-snackbar>

                <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="400px">

                    <v-card color="grey lighten-5">

                        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>

                            <v-layout row="" wrap="">

                                <div class="flex md12">
                                    <v-layout>
                                        <v-text-field hide-details="" style="padding-right:5px;" v-model="GelenFatura.FaturaSeri" :label="$t('Invoice-Serial')" required> </v-text-field>

                                        <v-text-field hide-details="" v-model="GelenFatura.FaturaNo" :label="$t('Invoice-No')" required>
                                        </v-text-field>

                                    </v-layout>
                                </div>

                                <div class="flex md12">
                                <cariaracomp v-bind:etiket="$t('Accound-Code')" :loading="loading" v-bind:value="GelenFatura.CariKodu" v-model="GelenFatura.CariKodu"></cariaracomp>
                                </div>
                                <div class="flex md12">
                                    <v-layout>
                                        <parainput :simge="getparabirimi()" style="padding-right:3px;" v-model="GelenFatura.BaslangicTutar" :etiket="$t('Min-Amount')" :autocomplete="autocomplete">
                                        </parainput>

                                        <parainput :simge="getparabirimi()" :name="maxtutar" v-model="GelenFatura.BitisTutar" :etiket="$t('Max-Amount')" :autocomplete="autocomplete"></parainput>
                                    </v-layout>
                                </div>

                                <div class="flex md12">

                                    <div class="card__text grey darken-1 white--text">
                                        <h3>{{$t('Options')}}</h3>
                                    </div>
                                    <v-checkbox :label="$t('All-Companies')" hide-details="" v-model="tumsirketler"></v-checkbox>
                                </div>
                            </v-layout>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card>
    </v-app>

    <v-dialog scrollable="" max-width="850px">
        <v-card>
            <v-card-title>{{ $t('E-Invoice') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap="">
                    <reportbrosablon ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>

                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="faturadialog" scrollable="" max-width="850px">
        <v-card>
            <v-card-title>{{ $t('E-Invoice') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap="">
                    <div class="flex md12">
                        <span id="demo2">
                        </span>
                    </div>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import tarihcomp from '../customcomp/tarihim'
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'

export default {
    data() {
        return {

            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },
            filtrevarmi: false,
            siralamatipi: 'InvoiceDate',
            kayitadet: 50,
            recordcount: null,
            kayitvarmi: false,
            secilenkayitlar: [],
            pagenumber: 1,
            sayfalama: 1,

            headers: [{
                    text: this.$t('Invoice-Date'),
                    value: 'FaturaTarih'
                }, {
                    text: this.$t('Invoice-Serial'),
                    value: 'FaturaSeri',

                },
                {
                    text: this.$t('Invoice-No'),
                    value: 'FaturaNo',
                },

                {
                    text: this.$t('Currentcode_label'),
                    value: 'CariKodu'
                },
                {
                    text: this.$t('Amount'),
                    value: 'Tutar'
                }
            ],
            dizayn: null,
            vmodelpagination: false,
            serbestAdet: 0,
            coperAdet: 0,
            biletAdet: 0,
            ToplamAdetbilcopser: 0,
            kagıtAdet: 0,
            efaturaAdet: 0,
            earsivAdet: 0,
            ToplamAdetkagefatears: 0,
            toplamKDV: 0,
            ToplamMatrah: 0,
            ToplamKDVMat: 0,

            tumunuseckaldir: false,

            searchliste: null,
            listegorunum: true,
            gorunumtipi: 'list',
            tablegorunum: false,
            kayitsayisivmodel: 50,
            kayitsayisi: [{
                text: '50',
                value: 50
            }, {
                text: '100',
                value: 100
            }],
            siralamavmodel: 0,
            siralamatipiitems: [{
                text: this.$t('Date-Ascending'),
                value: 'InvoiceDate'
            }, {
                text: this.$t('Date-Descending'),
                value: 'InvoiceDateDesc'
            }, {
                text: this.$t('Current-Ascending'),
                value: 'InvoiceCurrentCode'
            }, {
                text: this.$t('Current-Descending'),
                value: 'InvoiceCurrentCodeDesc'
            }, {
                text: this.$t('Increasing-per-Amount'),
                value: 'InvoiceAmount'
            }, {
                text: this.$t('Decreasing-per-Amount'),
                value: 'InvoiceAmountDesc'
            }, ],

            filtreticket: [],
            indexsayisi: 10,

            tooltip: false,
            el: null,

            GelenFatura: {
                SirketKodu: null,
                BaslangicTarih: null,
                BitisTarih: null,
                FaturaSeri: null,
                FaturaNo: null,
                CariKodu: null,
                BaslangicTutar: 0,
                BitisTutar: 0,
                Paging: {
                    SayfaNo: 1,
                    VeriAdet: 50,
                    SiralamaTip: 'InvoiceDate'
                }
            },
            faturadialog: false,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',
            date2: null,
            date2yedek: null,
            menu2: false,
            dateFormatted2: '',
            modal2: false,
            loading: false,
            loading1: false,
            search3: '',
            renk: 'white',
            renk1: 'info',
            items: [],
            load: false,
            load1: true,
            butondurum: true,
            hesapkodu: [],
            anahesap: [],
            hesapgurubu: [],
            e6: [],
            tumsirketler: false,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1: '',
            search: '',
            search1: '',
            cariKod: '',
            progress: false,

            dictionary: {
                custom: {

                    tarihsecbas: {
                        required: () => this.$t('Please-select-a-date')
                    },
                    tarihsecbit: {
                        required: () => this.$t('Please-select-a-date')
                    },
                }
            },

            maxtutar: 'maxtutar',
            autocomplete: 'autocomplete',
            etiket: 'Max Tutar',
            dialogfatura: false,
            mintutar: 'mintutar',
            etiketmin: 'Min Tutar',

            filtre: {
                a: '',
                b: '',
                c: ''
            },
            dialogfiltre: false,

        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    beforeMount: beforeMount,
    mounted() {
        this.el = this.$refs.fab.$el

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

            this.date = helpers.getDateNow()
            this.date2 = helpers.getDateNow()

            this.load1 = false

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.GelenFatura.SirketKodu = credentials.SirketKodu
            this.GelenFatura.BaslangicTarih = this.date
            this.GelenFatura.BitisTarih = this.date2

            var params = this.GelenFatura

            this.$http.post(auth.API_URL + 'api/Invoice/IncomingInvoiceList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                this.load1 = true
                this.items = response.body

                if (response.body.length == 0) {
                    this.text1 = this.$t('No-Records-Found')
                    this.snackbar = true
                }
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.progress = false
                    this.load1 = true

                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.progress = false
                    this.load1 = true
                }
            })

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        let url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        let url = '#/'
                        window.open(url, '_self')
                    }
                } 

            });

        }
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },

        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }

    },

    components: {
        'parainput': parainput,
        reportbrosablon,
        tarihcomp,
        yetkidialog,
        cariaracomp
    },
    watch: {
        'kayitadet': function (valueveriadet) {
            this.getList(1, valueveriadet, this.siralamatipi, false)
            //sayfanoo, kayitadett, siralatipp, aramayapildimi
        },
        'siralamatipi': function (tip) {
            this.sayfalama = 1;
            this.getList(1, this.kayitadet, tip, false)

            //sayfanoo, kayitadett, siralatipp, aramayapildimi
        },
        'sayfalama': function (sayfa) {
            this.getList(sayfa, this.kayitadet, this.siralamatipi, false)
            //sayfanoo, kayitadett, siralatipp, aramayapildimi
        },
    },
    methods: {
        getcopersirketadi(val) {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var kayitvarmi = credentials.CoperSirketler.filter(function (el) {
                return el.SirketNo == val
            });

            if (kayitvarmi.length == 1) {
                return kayitvarmi[0].SirketKod
            } else {
                return this.$t('Unidentified')
            }

        },
        getparabirimi() {
            return helpers.getparabirimi()
        },
        gelentfaturaEkle(val) {

            if (val == 1) {
                let link = '#/fatura/serbestfatura/yeni?islem=yenigelenevrak'
                window.open(link, '_self')
            } else if (val == 2) {
                let link = '#/fatura/copergelenfatura/id?islem=yeni'
                window.open(link, '_self')
            }

        },

        getList: getList,
        getListHtml: getListHtml,
        getListExcel: getListExcel,
        filtrele: filtrele,
        filtrekayit: filtrekayit,
        filtreiptal: filtreiptal,
        git: git,
        kayitcek: kayitcek,
        efaturagoster: efaturagoster,
        tarihkontrol: tarihkontrol,
        reportbrobas: reportbrobas,
        SaticiTipConvert: SaticiTipConvert
    },
}

function git(prm) {
    if (prm.Program != 3) {
        var url = '#/fatura/serbestfatura/id?' + 'ft=' + prm.FaturaTarih + '&ck=' + unescape(prm.CariKodu) + '&et=' + null +
            '&es=' +
            prm.FaturaSeri + '&en=' + prm.FaturaNo + '&ner=' + "X" + '&sb=' + false + '&islem=gelenevrak'
        window.open(url, '_target')

    } else if (prm.Program == 3) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                
        if (credentials.CoperSirketNo == prm.CoperSirketNo) {
            var saticiTip = SaticiTipConvert(prm.CoperSaticiTip)
            let url = "#/fatura/copergelenfatura/id?islem=get&st=" + prm.CoperSaticiTip + '&sk=' + escape(prm.CoperSaticiKod.replace('&','%26')) +
                '&fs=' + prm
                .FaturaSeri + '&fn=' + prm.FaturaNo + '&ft=' + prm.FaturaTarih
            window.open(url, "_target");
        } else {

            var copersirketadi = this.getcopersirketadi(prm.CoperSirketNo)
            this.text1 = 'Bu fatura ' + copersirketadi +
                ' isimli coper şirketine aittir, faturayı görmek için ilgili coper şirketini aktif etmeniz gerekmektedir.'
            this.snackbar = true
        }

    }

}

function SaticiTipConvert(text) {
    var trMap = {
        '&': '%26',

    };
    for (var key in trMap) {
        text = text.toString().replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
    }
    return text;
}

function efaturagoster(v, y) {

    var params = {
        id: y,
        guid: v
    }
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            'CariSirketNo': credentials.SirketKodu.toString(),
            'CoperSirketNo': credentials.CoperSirketNo.toString(),
        }
    }).then((response) => {
        this.faturadialog = true
        document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-FaturaShow'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-FaturaShow'
            this.snackbar = true
        }
    })
}

function reportbrobas(v, y, dizaynkod) {

    this.dizayn = dizaynkod;

    var prm = {
        id: y,
        guid: v
    };

    this.$refs.reportbrosablon.Print(prm, this.Fatura.FaturaBilgi.FaturaPdfID).then(
        confirm => {
            if (confirm.sonuc != true) {
                 this.text1 = confirm.mesaj
                this.snackbar = true
            } 
        });
}

function tarihkontrol(v) {

    if (v != "0001-01-01T00:00:00") {
        var parts = v.split("T");
        var parts1 = parts[0].split("-");
        return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
    } else {
        return null;
    }
}

function getList(sayfanoo, kayitadett, siralatipp, aramayapildimi) {

    this.$validator.validateAll().then((result) => {

        if (result) {

            var bastarih = new Date(this.date)
            var bittarih = new Date(this.date2)

            if (bastarih <= bittarih) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.progress = true
                this.load1 = false

                if (this.tumsirketler === true) {
                    this.GelenFatura.SirketKodu = '0'
                } else {
                    this.GelenFatura.SirketKodu = credentials.SirketKodu

                }
                this.GelenFatura.Paging.SayfaNo = sayfanoo
                this.GelenFatura.Paging.VeriAdet = kayitadett
                this.GelenFatura.Paging.SiralamaTip = siralatipp

                this.GelenFatura.BaslangicTarih = this.date
                this.GelenFatura.BitisTarih = this.date2

                var params = this.GelenFatura

                this.$http.post(auth.API_URL + 'api/Invoice/IncomingInvoiceList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.load1 = true
                    this.items = response.body

                    if (response.body.length == 0) {
                        this.text1 = this.$t('No-Records-Found')
                        this.kayitvarmi = false
                        this.vmodelpagination = false
                        this.snackbar = true
                    } else {
                        this.kayitvarmi = true
                        this.vmodelpagination = true
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.vmodelpagination = false
                        this.kayitvarmi = false
                        this.progress = false
                        this.load1 = true

                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.vmodelpagination = false
                        this.kayitvarmi = false
                        this.progress = false
                        this.load1 = true
                    }
                })

            }
        }

    })

}

function kayitcek(v) {

    var params = {
        id: v.EFaturaShowID.EFaturaID,
        guid: v.EFaturaShowID.EFaturaGuid
    }

    this.$http.post(auth.API_URL + 'api/EFatura/GetFatura', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.faturadialog = true
        document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-Iskonto Hesapla'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-Iskonto Hesapla'
            this.snackbar = true
        }
    })
}

function getListHtml() {

    this.$validator.validateAll().then((result) => {

        if (result) {

            var bastarih = new Date(this.date)
            var bittarih = new Date(this.date2)

            if (bastarih <= bittarih) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                var lang = localStorage.getItem('lang')
                this.progress = true
                this.load1 = false

                if (this.tumsirketler === true) {
                    this.GelenFatura.SirketKodu = '0'
                } else {
                    this.GelenFatura.SirketKodu = credentials.SirketKodu
                }

                this.GelenFatura.Paging.SayfaNo = null
                this.GelenFatura.Paging.VeriAdet = null

                this.GelenFatura.BaslangicTarih = this.date
                this.GelenFatura.BitisTarih = this.date2

                var params = this.GelenFatura

                this.$http.post(auth.API_URL + 'api/Invoice/IncomingInvoiceListHtml', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.load1 = true
                    if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText) ;
             
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>GELEN FATURA LİSTESİ</font>"," <font face = 'Arial' size = '4' color = '#FFFFF0'>List of Invoices Received</font>");
             bodyhtml=bodyhtml.toString().replace('GELEN FATURA LİSTESİ','List of Invoices Received');
             bodyhtml=bodyhtml.toString().replace('Fatura Tarihi','Invoice Date');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Fatura Seri</font>","<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Invoice Serial</font>");
             bodyhtml=bodyhtml.toString().replace('Fatura No','Invoice No');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Fatura No</font>","<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Invoice No</font>");
             bodyhtml=bodyhtml.toString().replace('Unvani','Title');
             bodyhtml=bodyhtml.toString().replace('Tutar','Total');
             bodyhtml=bodyhtml.toString().replace('Aralığı ','Between');
             bodyhtml=bodyhtml.toString().replace(" adet kayıt listelendi.</b>"," Record Listed.</b>");
             
             response.bodyText=bodyhtml;
             
          }
                    var blob = new Blob([response.bodyText], {
                        type: 'application/html'
                    });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download =this.$t('GelenFaturaList') + ".html";
                    link.click();

                    if (response.body.length == 0) {
                        this.text1 = this.$t('No-Records-Found')
                        this.snackbar = true
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.progress = false
                        this.load1 = true

                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.progress = false
                        this.load1 = true
                    }
                })

            }
        }

    })
}

function getListExcel() {

    this.$validator.validateAll().then((result) => {

        if (result) {

            var bastarih = new Date(this.date)
            var bittarih = new Date(this.date2)

            if (bastarih <= bittarih) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.progress = true
                this.load1 = false

                if (this.tumsirketler === true) {
                    this.GelenFatura.SirketKodu = '0'
                } else {
                    this.GelenFatura.SirketKodu = credentials.SirketKodu
                }
                this.GelenFatura.Paging.SayfaNo = null
                this.GelenFatura.Paging.VeriAdet = null

                this.GelenFatura.BaslangicTarih = this.date
                this.GelenFatura.BitisTarih = this.date2

                var params = this.GelenFatura

                this.$http.post(auth.API_URL + 'api/Invoice/IncomingInvoiceListExcel', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    },
                    responseType: "arraybuffer"
                }).then((response) => {

                    this.load1 = true
                    var blob = new Blob([response.data], {
                        type: 'application/xlsx'
                    });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.$t('GelenFaturaList') + ".xlsx"; 
                    link.click();

                    if (response.body.length == 0) {
                        this.text1 = this.$t('No-Records-Found')
                        this.snackbar = true
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.progress = false
                        this.load1 = true

                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.progress = false
                        this.load1 = true
                    }
                })

            }
        }

    })
}

function beforeMount() {

}

function filtrele() {
    this.dialogfiltre = true
}

function filtrekayit() {
    this.dialogfiltre = false
    this.filtrevarmi = true
    this.getList(1, this.kayitadet, this.siralamatipi, true)

}

function filtreiptal() {

    this.filtrevarmi = false,
        this.dialogfiltre = false
    this.GelenFatura.CariKodu = null
    this.GelenFatura.FaturaSeri = null
    this.GelenFatura.FaturaNo = null
    this.GelenFatura.BaslangicTutar = 0
    this.GelenFatura.BitisTutar = 0
    this.tumsirketler = false
    this.getList(1, this.kayitadet, this.siralamatipi, false)

}
</script>

<style>
</style>
